/**
 * Glstsho Theme - Main Entry Point
 * Initialize all theme modules
 */
import { eventBus } from './utils/event-bus.js';
import { $, $$, debounce } from './utils/helpers.js';

class GlstshoTheme {
  constructor() {
    this.modules = new Map();
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    this.initModules();
    this.bindEvents();

    console.log('Glstsho Theme initialized');
  }

  initModules() {
    const moduleElements = $$('[data-glstsho-module]');

    moduleElements.forEach(el => {
      const moduleName = el.dataset.glstshoModule;
      this.initModule(moduleName, el);
    });
  }

  initModule(name, el) {
    if (this.modules.has(name)) return;

    const ModuleClass = this.getModuleClass(name);
    if (ModuleClass) {
      const instance = new ModuleClass(el);
      this.modules.set(name, instance);
    }
  }

  getModuleClass(name) {
    const modules = {
      // Add custom modules here
      // 'product-card': ProductCard,
      // 'modal': Modal,
    };
    return modules[name] || null;
  }

  bindEvents() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init();
    });

    window.addEventListener('resize', debounce(() => {
      eventBus.emit('theme:resize');
    }, 100));
  }

  getModule(name) {
    return this.modules.get(name);
  }
}

export const theme = new GlstshoTheme();
